import { render } from "./MaterialLoading.vue?vue&type=template&id=daaad95c&scoped=true"
import script from "./MaterialLoading.vue?vue&type=script&lang=js"
export * from "./MaterialLoading.vue?vue&type=script&lang=js"

import "./MaterialLoading.vue?vue&type=style&index=0&id=daaad95c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daaad95c"]])

export default __exports__